import { createVanIconComponent } from "./van"

const Coupon = createVanIconComponent("coupon")
export default Coupon
